"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hashStyle;

var _murmurHash = _interopRequireDefault(require("@adeira/murmur-hash"));

function hashStyle(style) {
  // CSS class cannot start with number
  return (0, _murmurHash.default)(style).replace(/^[0-9]/, function (s) {
    return "_".concat(s);
  });
}